import { fromEvent } from "rxjs";
import { throttleTime, share, map } from "rxjs/operators";

export function getMainContentScroll$() {
    const content = document.querySelector('.mat-sidenav-content');
    return fromEvent(content, 'scroll').pipe(
      throttleTime(10), // only emit every 10 ms
      map(() => content.scrollTop), // get vertical scroll position
      share(), // share a single subscription to the underlying sequence in case of multiple subscribers
    );

}
